// TypeaheadWidget.js
import React, { useCallback } from "react";
import AsyncSelect from "react-select/async"; // Install: npm install react-select
import debounce from "lodash/debounce";
import {Stack } from "@chakra-ui/react";


const TypeaheadWidget = ({
  id,
  value,
  required,
  onChange,
  label,
  fetchOptions,
  handleChangeCB,
  onSelectionChange,
  readonly,
  disabled,
  schema,
  uiSchema
}) => {
    // Check if the field should be readonly or disabled
    const isReadOnly = readonly || disabled || uiSchema?.["ui:readonly"] || uiSchema?.["ui:disabled"];

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedFetchOptions = useCallback(
        debounce((inputValue, callback) => {
          fetchOptions(inputValue).then(callback);
        }, 300), // 300ms delay
        []
      );

  const handleChange = (selectedOption) => {
    if (isReadOnly) return; // Prevent changes if readonly
    onChange(selectedOption ? selectedOption.value : '');
    handleChangeCB && handleChangeCB(selectedOption ? selectedOption.value : '');
    onSelectionChange && onSelectionChange(selectedOption);
  };
  
  return (
    <Stack pb={"5px"} gap={"10px"}>
      <label htmlFor={id} style={{ fontSize: "14px" }}>
        {label} {required && <span style={{ color: "red" }}>*</span>}
      </label>
      {isReadOnly ? (
        // If readonly, render as plain text
        <div style={{ 
          padding: "8px 12px", 
          border: "1px solid #e2e8f0", 
          borderRadius: "4px", 
          backgroundColor: "#f8f9fa",
          color: "#718096"
        }}>
          {value || ""}
        </div>
      ) : (
        // Otherwise render the AsyncSelect
        <AsyncSelect
          id={id}
          cacheOptions
          defaultOptions={false}
          noOptionsMessage={() => "No Options Found / Start typing to search"}
          loadOptions={debouncedFetchOptions}
          value={value ? { label: value, value } : null}
          onChange={handleChange}
          placeholder="Start typing to search..."
          isClearable={true}
        />
      )}
    </Stack>
  );
};

export default TypeaheadWidget;
